import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import default_product from '../../../../assets/media/icons/products.png';
import { Column, ImagesViewer } from '../../../../components/Basic/Blocks/index.js';
import { AnimateArrow, Button, ButtonWithTooltip } from '../../../../components/Basic/Buttons/index.js';
import { TableCell, TableLine } from '../../../../components/Basic/Table/index.js';
import { TextGrey } from '../../../../components/Basic/WrapsStyle/index.js';
import PenaltyPopUp from '../../../../components/Shipments/Blocks/PenaltyPopUp/index.js';
import { TO_PRODUCT, TYPE_BUTTONS } from '../../../../constans/index.js';
import { formFullDate } from '../../../../utils/index.js';
import CommentPostingProductBlock from '../../../Shipments/Posting/CommentBlock/index.js';
import WarehouseHistoryBlock from '../../../Warehouse/WarehouseProducts/ProductHistory/Content/index.js';
import { WIDTH_POSTING } from '../index.js';
import styles from './styles.module.scss';

const STATE = {
  not_started: { text: 'Не собран', color: '' },
  started: { text: 'Комплектуется', color: 'rgb(255 112 0 / 18%)' },
  collected: { text: 'Собран', color: 'rgb(88 143 255 / 37%)' },
  packed: { text: 'Упакован', color: 'rgb(69 255 156 / 51%)' },
  printed: { text: 'Упакован', color: '#39ee3f47' },
};

const COLOR_MARKET = {
  wb: '#6c11c9',
  yandex: 'rgb(193 61 0)',
  ozon: 'rgb(19,79,231)',
  megamarket: 'rgb(13,131,25)',
  kuper: 'rgb(13,131,25)',
};

const WarehouseLine = ({
  FILTER,
  tab,
  product = {},
  isOwner = false,
  width = [],
  skladName = '',
  onChange = () => { },
  action = {},
  isAdmin = false,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [isOpenHistory, setIsOpenHistory] = useState(false);

  const [images, setImages] = useState([]);

  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  useEffect(() => {
    setIsOpenHistory(false);
  }, [product.id]);

  return (
    <>
      <TableLine key={product.id}>
        <TableCell width={width[10]}>
          <ImagesViewer images={[product.image || default_product]} />
        </TableCell>
        <TableCell width={width[0]}>
          <div className={styles.block}>
            {product.id}
            <ButtonWithTooltip
              tooltip={isOpenHistory ? 'Скрыть историю изменений' : 'Показать историю изменений'}
              onClick={() => setIsOpenHistory(!isOpenHistory)}
            >
              <AnimateArrow isOpen={isOpenHistory} styles={cn(styles.open_icon_arrow)} />
            </ButtonWithTooltip>
          </div>
        </TableCell>
        <TableCell width={width[1]} fontSize="14px">
          <Column>
            <Link to={TO_PRODUCT(product.id)} className={styles.link} target="_blank">
              {product.name}
            </Link>
            <TextGrey style={{ width: '100%', fontSize: '12px' }}>{product.category}</TextGrey>
          </Column>
        </TableCell>
        <TableCell width={width[6]}>{formFullDate(action.date)}</TableCell>

        <TableCell width={width[6]} center>
          {action.quantity}
        </TableCell>
        <TableCell width={width[6]} center>
          {action.user}
        </TableCell>
        <TableCell width={width[11]}>{action.reason}</TableCell>
        <TableCell width={WIDTH_POSTING[11]}>
          <Column>
            <div key={`${action._id}-14`} className={styles.div_line}>
              <CommentPostingProductBlock
                posting={{ history: product.sklad_data[skladName]?.comments || [] }}
                offer_id={action._id}
                key_mapping={'history_id'}
                onChange={(v) => onChange(product.id, action._id, 'comment', v, 'add')}
                width={'230px'}
              />
            </div>
          </Column>
        </TableCell>

        {isAdmin && (
          <TableCell width={WIDTH_POSTING[11]}>
            <div key={`${product.id}-${action._id}-13`} className={styles.div_line}>
              <Button
                type={TYPE_BUTTONS.GREEN}
                style={{ marginRight: '15px' }}
                disabled={action.result?.is_closed}
                onClick={() => onChange(product.id, action._id, 'checkup_is_closed', true)}
              >
                Решено
              </Button>

              <PenaltyPopUp
                disabled={action.result?.is_closed}
                onChangeProduct={(data) => onChange(product.id, action._id, 'penalty', data)}
              />
            </div>
          </TableCell>
        )}

        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
      {isOpenHistory && (
        <div className={styles.history_block}>
          {product.sklad_data[skladName].history.map((item) => (
            <WarehouseHistoryBlock part={item} key={item['_id']} />
          ))}
        </div>
      )}
    </>
  );
};

export default WarehouseLine;
